import {
  LOGIN_FACEBOOK_FORM_SEND,
  LOGIN_FAILED,
  LOGIN_FORM_SEND,
  LOGIN_SUCCESSED
} from 'src/app/redux/actions/login/login';


const initialState = {
  loading: false
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_FORM_SEND:
    case LOGIN_FACEBOOK_FORM_SEND:
      return { ...state, loading: true };
    case LOGIN_SUCCESSED:
    case LOGIN_FAILED:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default loginReducer;
